import { Divider, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { mapByRefValue } from '../../../components/Details/Details';
import DetailsOASkeleton from '../../../components/Skeletons/DetailsOASkeleton';
import { fetchForeasDetails, fetchSullogesDetails } from '../../../lib/fetchers';
import { _collectionsBasicInfo, _foreas } from '../../../lib/static/oa/sulloges/details';
import Theme from '../../../Themes/main.theme';
import DetailsSulloges from './DetailsSulloges';
import { collectionDetails, mapCollectionDetails } from './helperFuncs';
import { useContext } from 'react';
import BreadcrumbContext from '../../../components/context/BreadcrumbContext';
import { useTranslation } from 'react-i18next';
import EmptyPage from '../../../components/EmptyPage/EmptyPage';
import { useSnackbar } from 'notistack';
import i18n from '../../../i18n';
import { getItemId } from '../../../lib/helperFuncs';

function SmartDetailsSulloges() {
  const { id } = useParams();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [collectionsInfo, setCollectionsInfo] = useState<any>(_collectionsBasicInfo);
  const [documents, setDocuments] = useState<any>([]);
  const [title, setTitle] = useState<string>('');
  const [titleEN, setTitleEN] = useState<string>('');
  const [organisation, setOrganisation] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [errorMsg, setErrorMsg] = useState<string | any>();
  const { setName } = useContext(BreadcrumbContext.BreadcrumbProvider.context);

  const fetchData = async () => {
    try {
      setName('');
      const detailsResp = await fetchSullogesDetails(id);
    

      const collectionsRelateOrganisationId = detailsResp.item?.['collections:collectionsRelateOrganisation']?.[0]?.['@id'];
      const org_id = collectionsRelateOrganisationId
        ? getItemId(collectionsRelateOrganisationId)
        : null;
      const organisation_details = await fetchForeasDetails(org_id);
      const foreas_en_title = organisation_details.item?.['organisations:organisationsEnNameEn']?.[0]?.['@value'];      
      
      if (!detailsResp?.item?.['o:is_public']) throw new Error;

      document.title = (i18n.language === 'el'
        ? detailsResp?.item?.['o:title']
        : detailsResp?.item?.['collections:collectionsEnTitle']?.[0]?.['@value']);
      setName(i18n.language === 'el'
        ? detailsResp?.item?.['o:title']
        : detailsResp?.item?.['collections:collectionsEnTitle']?.[0]?.['@value']);
      setTitle(detailsResp?.item?.['o:title']);
      setTitleEN(detailsResp?.item?.['collections:collectionsEnTitle']?.[0]?.['@value']);
      
      const _mappedMetadata = mapCollectionDetails(detailsResp.item, foreas_en_title);
      
      const results = collectionDetails(detailsResp);
      setDocuments({
        ...results,
        relateOrganisation: _mappedMetadata.collectionOrganisation[0]
      });
      
      const _resourceIds = {
        collectionOrganisation: `/search-organisation/details/${[_mappedMetadata.collectionOrganisationResourceId]}`,
        collectionOrganisationEn: `/search-organisation/details/${[_mappedMetadata.collectionOrganisationResourceId]}`,
      };

      const mappedOmekaToRefValues =
      mapByRefValue(_mappedMetadata, _foreas(_mappedMetadata).map((x:any) => {
        return {
          ...x, name: t(x.name)
        };
      }));

      const newValues = mappedOmekaToRefValues.map(x => {        
        return { ...x, url: _resourceIds[x.refValue as keyof typeof _resourceIds] };
      });
      setOrganisation(newValues);
      setCollectionsInfo(
        mapByRefValue(_mappedMetadata, _collectionsBasicInfo(_mappedMetadata)).map(x => {
          return {
            ...x, name: t(`${x.name}`)
          };
        })
      );
      setIsLoading(false);
    } catch (error) {
      enqueueSnackbar(t('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα'), { variant: 'error' });
      console.error(error);
      setErrorMsg(t('Η σελίδα που ζητήσατε δεν βρέθηκε.'));
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {isLoading
        ? <DetailsOASkeleton length={2} />
        : errorMsg ? 
          <Box id='container-details' sx={{ m: 2, height: '600px' }}>
            <EmptyPage errorMsg={errorMsg} />
          </Box>
          : <Box id='container-details'
            width='100%'>
            <Typography sx={{ my: 2 }} variant='h2'
              color={Theme?.labelColor?.main}>{title}</Typography>
            <Typography sx={{ my: 2 }} variant='h2'
              color={Theme?.labelColor?.main}>{titleEN}</Typography>
            <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />
            <DetailsSulloges
              isLoading={isLoading}
              sullogesInfo={collectionsInfo}
              documents={documents}
              foreas={organisation}
            />
          </Box>
      }

    </>
  );
}

export default SmartDetailsSulloges;